/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import {
  Button,
  Chip,
  Tooltip,
  IconButton,
  Badge
} from "@mui/material";
import { DeleteSharp, EditSharp, RemoveRedEye, Schedule } from "@mui/icons-material";
import moment from "moment";
import { Routes } from "src/constant/api_url";
import CustomLoader from "src/commonComponents/CustomLoader";
import ScheduleModal from "./ScheduleModal";

function NotificationTable({
  data,
  isLoading,
  loginUser,
  onDelete,
  onEdit,
  onViewRead,
  pagination,
  onPageChange,
  onPerRowsChange
}) {
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [scheduleParentRow, setScheduleParentRow] = useState(null);

  const handleOpenSchedule = (row) => {
    setScheduleParentRow(row);
    setScheduleModalOpen(true);
  };

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row.n_id,
      sortable: true,
      width: "70px"
    },
    {
      name: "Type",
      wrap: true,
      width: "80px",
      selector: (row) => row.Notification_type
    },
    {
      name: "Image/Audio/Video",
      wrap: true,
      width: "150px",
      cell: (row) => {
        if (row.n_type === 1) {
          return (
            <audio controls src={`${Routes.API_HOSTNAME}images/notification/${row.n_image}`} />
          );
        } else if (row.n_type === 0) {
          return (
            <img
              src={`${Routes.API_HOSTNAME}images/notification/${row.n_image}`}
              alt="img"
              width="100"
            />
          );
        } else if (row.n_type === 2) {
          return row.n_video;
        } else {
          return "-";
        }
      }
    },
    {
      name: "Title",
      wrap: false,
      width: "150px",
      cell: (row) => {
        const content = row.n_title ?? "-";
        return (
          <div title={content}>{content.length > 30 ? content.slice(0, 30) + "..." : content}</div>
        );
      },
      sortable: true
    },
    {
      name: "URL",
      wrap: true,
      width: "120px",
      selector: (row) => (row.n_link != null && row.n_link != "" ? row.n_link : "-"),
      sortable: true
    },
    {
      name: "Button Title",
      wrap: true,
      width: "120px",
      selector: (row) =>
        row.n_button_title != null && row.n_button_title != "" ? row.n_button_title : "-",
      sortable: true
    },
    {
      name: "Question",
      wrap: false,
      width: "150px",
      cell: (row) => {
        const content = row.n_question ?? "-";
        return (
          <div title={content}>{content.length > 30 ? content.slice(0, 30) + "..." : content}</div>
        );
      },
      sortable: true
    },
    {
      name: "Answer",
      wrap: false,
      width: "150px",
      cell: (row) => {
        const content = row.n_answer ?? "-";
        return (
          <div
            title={content}
            dangerouslySetInnerHTML={{
              __html: content.length > 30 ? content.slice(0, 30) + "..." : content
            }}
          />
        );
      },
      sortable: true
    },
    {
      name: "Notification Send To",
      width: "90px",
      wrap: true,
      selector: (row) => row.Notification_Send_To
    },
    {
      name: "Notification For",
      width: "140px",
      wrap: true,
      selector: (row) => row.Notification_For
    },
    {
      name: "Notification To",
      width: "140px",
      wrap: true,
      selector: (row) => row.Notification_To
    },
    {
      name: "Location",
      wrap: true,
      width: "100px",
      selector: (row) =>
        loginUser.u_type != 0
          ? row.city_name
          : row.n_for_type == 1
            ? row.s_name
            : row.n_for_type == 2
              ? row.city_name
              : row.n_for_type == 3
                ? row.ch_name
                : "LVB"
    },
    {
      name: "Start Date",
      wrap: true,
      width: "120px",
      selector: (row) => row.s_date,
      sortable: true
    },
    {
      name: "End Date",
      selector: (row) => row.e_date,
      wrap: true,
      width: "120px",
      sortable: true
    },
    {
      name: "Created Date",
      selector: (row) => moment(row.timestamp).format("DD-MM-YYYY hh:mm A"),
      wrap: true,
      width: "180px",
      sortable: true
    },
    {
      name: "Schedules",
      width: "100px",
      center: true,
      cell: (row) => {
        const count = row.sub_count || 0;
        if (count <= 0) return null;
        return (
          <Tooltip title={`${count} schedule ${count === 1 ? "entry" : "entries"}`}>
            <IconButton size="small" onClick={() => handleOpenSchedule(row)}>
              <Badge badgeContent={count} color="primary" max={99}>
                <Schedule fontSize="small" />
              </Badge>
            </IconButton>
          </Tooltip>
        );
      },
      ignoreRowClick: true
    },
    {
      name: "Action",
      wrap: true,
      width: "150px",
      cell: (row) => (
        <>
          <Tooltip title="Delete">
            <span>
              <IconButton onClick={() => onDelete(row)}>
                <DeleteSharp color="error" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Edit">
            <span>
              <IconButton onClick={() => onEdit(row)}>
                <EditSharp color="warning" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="See Assign Member List">
            <IconButton onClick={() => onViewRead(row.n_id)}>
              <RemoveRedEye color="success" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  return (
    <>
      <DataTable
        highlightOnHover
        columns={columns}
        data={data != null && data}
        progressPending={isLoading}
        progressComponent={<CustomLoader />}
        pagination
        paginationServer
        paginationTotalRows={pagination?.totalRecords || 0}
        paginationPerPage={pagination?.perPage || 10}
        paginationDefaultPage={pagination?.currentPage || 1}
        onChangePage={onPageChange}
        onChangeRowsPerPage={onPerRowsChange}
      />
      <ScheduleModal
        open={scheduleModalOpen}
        onClose={() => {
          setScheduleModalOpen(false);
          setScheduleParentRow(null);
        }}
        parentRow={scheduleParentRow}
        onEdit={onEdit}
        onDelete={onDelete}
        onViewRead={onViewRead}
      />
    </>
  );
}

export default NotificationTable;
